import React, {useEffect} from 'react';
import Slider from '@personalization/scripts/components/Slider.jsx';
import SliderRecommendationItems from '@personalization/scripts/components/SliderRecommendationItems.jsx';
import WishlistHeartRecoWrapper from '@wishlist/components/WishlistHeartRecoWrapper.jsx';
import SliderLandmarkHelper from '@core/scripts/components/tracking/landmarks/slider-landmark-helper';
import {Carousel, Typography} from '@bonprix/design-system';
import ProductCard, {Touchpoint} from '@wishlist/components/product-card/ProductCard.jsx';
import onceVisible from '@core/scripts/helper/once-visible';

export default function ThorRecommendations({
                                                descriptive,
                                                recoData,
                                                className = 'recommendations',
                                                recommendationType,
                                                sliderType,
                                                onLinkClicked,
                                                optimizeButtonHandling,
                                                componentRef,
                                                numberOfItemsPerPage,
                                                gap,
                                                texts,
                                                carouselPadding,
                                                showArrows
                                            }) {

    const {landmarkData, recommendations, title} = recoData;

    useEffect(() => {
        if (recoData?.recommendations && componentRef?.current) {
            onceVisible(
                componentRef.current,
                () => {
                    onIsVisible({items: recoData?.recommendations, displayedItemCount: numberOfItemsPerPage});
                },
                1
            );
        }
    }, []);

    const onSlideChanged = (landmarkData) => {
        SliderLandmarkHelper.createSendSlideChangedLandmark(landmarkData);
    };

    const onSlideClicked = (clickedItem) => {
        const {productImageId, itemNumber, productDigistyleId, availabilityStatus} = clickedItem;
        SliderLandmarkHelper.createAndSendSlideClickedLandmark(
            sliderType,
            productImageId,
            itemNumber,
            productDigistyleId,
            availabilityStatus,
            landmarkData
        );
    };

    const onLinkClick = (clickedItem) => {
        onLinkClicked?.(recommendationType, clickedItem.productUrl);
    };

    const onProductCardClicked = (event, product) => {
        if (event.target.closest('a')) {
            event.preventDefault();
            const {assetId, articleNumber, digistyleId, soldOut} = product;
            const availabilityStatus = soldOut ? 'SOLDOUT' : 'AVAILABLE';
            SliderLandmarkHelper.createAndSendSlideClickedLandmark(
                sliderType,
                assetId,
                articleNumber,
                digistyleId,
                availabilityStatus,
                landmarkData
            );
            onLinkClicked?.(recommendationType, product.productLink);
        }
    };

    const onIsVisible = (event) => {
        if (!landmarkData.type && landmarkData.landmarkType) {
            landmarkData.type = landmarkData.landmarkType;
        }
        SliderLandmarkHelper.createAndSendSliderVisibilityLandmark(sliderType, event, landmarkData);
    };

    if (recommendations?.length === 0) {
        return null;
    }

    return (
        recommendations?.length > 0 && (
            <>
                <div className='mb-10 l:mb-20' ref={componentRef}>
                    <div className="mb-4 ml-2.5 xl:ml-12">
                        <Typography variant="bonprix-h4" component="div" align="left">
                            {title}
                        </Typography>
                        <Typography variant="bonprix-subtitle1" color="on-bg-low" component="div" align="left">
                            {descriptive}
                        </Typography>
                    </div>
                    <Carousel label="label"
                              gap={gap}
                              arrows={showArrows}
                              pagination={false}
                              padding={{
                                  right: `${carouselPadding}px`,
                              }}
                              perPage={numberOfItemsPerPage}
                              perMove={numberOfItemsPerPage}
                              onMove={() => onSlideChanged(landmarkData)}
                    >
                        {recommendations.map((product, index) => (
                            <Carousel.Slide key={recommendationType + '-carousel-' + index}>
                                <div onClick={(e) => onProductCardClicked(e, product)}>
                                    <ProductCard item={product} touchpoint={Touchpoint.RECOMMENDATION}
                                                 texts={texts}/>
                                </div>
                            </Carousel.Slide>
                        ))}
                    </Carousel>
                </div>
            </>
        )
    );
}
